export default __webpack_public_path__ + "static/media/lipstick2.71b2800d.jpg";